export default "__VITE_ASSET__y7t00NZ5__"